// extracted by mini-css-extract-plugin
export var fadeInOut = "_39-3";
export var icon = "_39-4";
export var savedIndicator = "_39-2";
export var savingIndicator = "_39-0";
export var spin = "_39-1";